import { lensMaterials } from '../config'
import {
  BULK_ORDER_HI_INDEX_THRESHOLD,
  BULK_ORDER_MATERIAL_GROUP_ORDER,
  BULK_ORDER_MATERIAL_GROUPS,
  BULK_ORDER_UNKNOWN_MATERIAL_GROUP,
  COATING_FILTER_VALUES,
} from './config'
import { fullNormalizeForSearch } from '../lib/text'

export { COATING_FILTER_VALUES }

export const normalizeCatalogId = catalogId => {
  if (catalogId == null || catalogId === '') return null
  return String(catalogId)
}

const filterCatalogByName = (item, searchText = '') => {
  if (!searchText) return true
  if (!item?.name) return false

  const normalizedName = fullNormalizeForSearch(item.name)
  const searchTextParts = fullNormalizeForSearch(searchText).split(' ').filter(Boolean)

  return searchTextParts.every(part => normalizedName.includes(part))
}

const isHiIndex = opticalIndex =>
  opticalIndex != null && opticalIndex > BULK_ORDER_HI_INDEX_THRESHOLD

export const getBulkOrderMaterialGroupKey = lens => {
  if (!lens?.material) return null

  const { material, opticalIndex } = lens

  if (material === lensMaterials.MINERAL) {
    return isHiIndex(opticalIndex)
      ? BULK_ORDER_MATERIAL_GROUPS.MINERAL_HI_INDEX
      : BULK_ORDER_MATERIAL_GROUPS.MINERAL
  }

  if (material === lensMaterials.PLASTIC) {
    return isHiIndex(opticalIndex)
      ? BULK_ORDER_MATERIAL_GROUPS.ORGANIC_HI_INDEX
      : BULK_ORDER_MATERIAL_GROUPS.ORGANIC
  }

  if (material === lensMaterials.TRIVEX) return BULK_ORDER_MATERIAL_GROUPS.TRIVEX
  if (material === lensMaterials.POLYCARBONATE) return BULK_ORDER_MATERIAL_GROUPS.POLYCARBONATE

  return null
}

export const matchesBulkOrderMaterialFilter = (lens, groupKey) => {
  if (!groupKey) return true
  return getBulkOrderMaterialGroupKey(lens) === groupKey
}

export const filterCatalog = (
  catalog,
  {
    searchText = '',
    materialKey = null,
    coatingKey = null,
    matchesMaterial = matchesBulkOrderMaterialFilter,
  } = {},
) =>
  (catalog || []).filter(item => {
    if (!filterCatalogByName(item, searchText)) return false
    if (!matchesMaterial(item, materialKey)) return false
    if (coatingKey && item.filterCoating !== coatingKey) return false
    return true
  })

export const compareBulkOrderCatalogItems = (a, b) =>
  (a.name || '').localeCompare(b.name || '')

export const groupCatalogByBulkOrderMaterial = catalog => {
  const groupsByKey = (catalog || []).reduce((result, item) => {
    const groupKey = getBulkOrderMaterialGroupKey(item) || BULK_ORDER_UNKNOWN_MATERIAL_GROUP
    if (!result[groupKey]) {
      result[groupKey] = []
    }
    result[groupKey].push(item)
    return result
  }, {})

  return BULK_ORDER_MATERIAL_GROUP_ORDER.filter(key => groupsByKey[key]?.length)
    .map(key => ({
      key,
      items: groupsByKey[key].sort(compareBulkOrderCatalogItems),
    }))
    .concat(
      groupsByKey[BULK_ORDER_UNKNOWN_MATERIAL_GROUP]?.length
        ? [
            {
              key: BULK_ORDER_UNKNOWN_MATERIAL_GROUP,
              items: groupsByKey[BULK_ORDER_UNKNOWN_MATERIAL_GROUP].sort(
                compareBulkOrderCatalogItems,
              ),
            },
          ]
        : [],
    )
}

export const getBulkOrderFilterOptions = catalog => {
  const materialGroupKeys = new Set()
  const coatingKeys = new Set()

  ;(catalog || []).forEach(item => {
    const groupKey = getBulkOrderMaterialGroupKey(item)
    if (groupKey) {
      materialGroupKeys.add(groupKey)
    }
    if (item.filterCoating) {
      coatingKeys.add(item.filterCoating)
    }
  })

  return {
    materialGroupKeys: BULK_ORDER_MATERIAL_GROUP_ORDER.filter(key => materialGroupKeys.has(key)),
    coatingKeys: COATING_FILTER_VALUES.filter(key => coatingKeys.has(key)),
  }
}
